export const DIALOG_MODE_FAVORITES = 'favorites';

export const DIALOG_MODE_LOADING = 'loading';

export const DIALOG_MODE_REWARDS_SHOP = 'rewardsShop';

export const DIALOG_MODE_STANDARD_BUY = 'standardBuy';
